export default "__VITE_ASSET__DSStjslU__"